import { Pipe, PipeTransform } from '@angular/core';
import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import * as timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);



@Pipe({
  name: 'overrideTimezone',
})

// TO SHOW THE TIME INFORMATION FROM THIS PIPE DATABASE WITHOUT CHANGE THE TIME
// BU PIPE VERİTABANINDAN GELEN ZAMAN BİLGİSİNİN SAATİNİ DEĞİŞTİRMEDEN GÖSTERMEK İÇİN
// 2023-03-06T08:00:00Z >>>> 2023-03-06T08:00:00+03:00

export class overrideTimezone implements PipeTransform {
  transform(dateString: string | Date, timezone: string, format?: string): string {

    // if (!timezone) {
    //   timezone = 'Europe/Istanbul';
    // }

    const d1 = dayjs.tz(dateString);
    if (format) {
      return d1.format(format);
    } else {
      return d1.format('HH:mm');
    }
  }
}